<i18n>
    [
        "product__shoppableImage--cta",
        "global__off",
    ]
</i18n>

<template>
    <div
        class="
            c-catalog-tile-banner
            o-flex-vertical-center
            o-flex-horizontal-center
            o-text--label
        "
        :class="{
            'c-catalog-tile-banner--shop-the-look': showShopTheLookBanner,
            'c-catalog-tile-banner--pre-purchase': isPrePurchase,
        }"
    >
        <template v-if="showShopTheLookBanner">
            <AppIcon
                :isCoreDir="true"
                icon="global--eye"
                size="16px"
                color="gray"
                class="c-catalog-tile-banner__icon"
            />
            {{ t('product__shoppableImage--cta') }}
        </template>
        <Badge
            v-else-if="isPrePurchase"
            class="c-catalog-tile-banner__badge o-text--caption"
            :badgeText="badgeText"
            icon="account--promo"
            :bkgColor="BADGE_COLORS.sunshine"
            color="black"
        />
    </div>
</template>

<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { useFilters } from '~coreModules/core/js/custom-filters';

import { BADGE_COLORS } from '~coreModules/core/js/badge-constants';

import Badge from '~coreModules/core/components/ui/Badge.vue';

const props = defineProps({
    showShopTheLookBanner: {
        type: Boolean,
        default: false,
    },
    isPrePurchase: {
        type: Boolean,
        default: false,
    },
    prePurchaseInfo: {
        type: Object,
        default: () => ({}),
    },
});

const { t } = useI18n();
const filters = useFilters();

const prePurchaseSalePrice = computed(() => (
    filters.i18nFormatDollarsNoCents(props.prePurchaseInfo.salePrice)
));
const discountPercentage = computed(() => `(${props.prePurchaseInfo.discountPercent}% ${t('global__off')})`);

const badgeText = computed(() => `${prePurchaseSalePrice.value} ${discountPercentage.value}`);

</script>

<style lang='scss'>
    .c-catalog-tile-banner {
        position: absolute;
        bottom: 0;
        width: 100%;
        height: $nu-spacer-4;
        pointer-events: none;

        &--shop-the-look {
            background-color: $nu-gray--light;
            color: $nu-gray;
            opacity: .8;
        }

        &--pre-purchase {
            background-color: $nu-sunshine-80;
            opacity: .9;
        }

        &__icon {
            margin-right: $nu-spacer-1;
        }

        &__badge {
            font-weight: $font-weight-medium;
        }
    }
</style>
